import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    fontWeight: 500
  },
  name: {
    marginBottom: theme.spacing(1)/2,
  },
  credentials: {
    marginBottom: theme.spacing(1)/2,
  },
  position: {
    marginBottom: theme.spacing(1)/2,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    fontWeight: 300,
    lineHeight: 1.6,
  },
  role: {
    fontWeight: 400,
    lineHeight: 1.6,
  },
  paragraph: {
    whiteSpace: 'pre-line',
    marginBottom: theme.spacing(3),
    maxWidth: '500px'
  },
  person: {
    marginBottom: theme.spacing(3),
  },
  outer: {
    maxWidth: '96px',
  },
  portrait: {
    paddingBottom: '100%',
    borderRadius: '50%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    backgroundColor: '#ddd'
  },
}));


const Speaker = (props) => {
  const classes = useStyles();
  return (
    <>
      <Grid container direction="row" alignItems="center" spacing={3} className={classes.person}>
        <Grid item xs={3}>
          <div className={classes.outer}><div className={classes.portrait} style={{ backgroundImage: `url('${props.config.imageUrl}')`}}></div></div>
        </Grid>
        <Grid item xs={9}>
          <h6 className={classes.position}>{props.config.title}</h6>
          <h3 className={classes.name}>{props.config.name}</h3>
          <h5 className={classes.credentials}>{props.config.credentials}</h5>
          <h5 className={classes.role}>{props.config.role}</h5>
        </Grid>
      </Grid>
      <p className={classes.paragraph}>{props.config.description}</p>
    </>
  );
};

export default (props) => {
  const classes = useStyles();
  return (
    <>
    <h2 className={classes.title}>{props.config.title}</h2>
    <Grid container direction="row" spacing={6}>
        {props.config.speakers.map((speaker, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Speaker config={speaker} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}